import { render } from "./AlertDialog.vue?vue&type=template&id=d2a05698&scoped=true"
import script from "./AlertDialog.vue?vue&type=script&lang=js"
export * from "./AlertDialog.vue?vue&type=script&lang=js"

import "./AlertDialog.vue?vue&type=style&index=0&id=d2a05698&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\mypage\\mypage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a05698"]])

export default __exports__